module.exports = __webpack_public_path__ + "img/tally-1.038bdba2.svg";